import React from "react";
import CMODetails from "./Stepper/steps/CMODetails";
import SiteDetails from "./Stepper/steps/SiteDetails";
import PlantDetails from "./Stepper/steps/PlantDetails";
import ShipmentConfigurations from "./Stepper/steps/Configurations";
import PurchasingDetails from "./Stepper/steps/PurchasingDetails";
import ErpToErpConfigurationSection from "./shared/ErpToErpConfigurationSection";
import { DEFAULT_PRODUCT_TYPES } from "./shared/erpToErpConfigData";
import useProductTypeNames from "./shared/useProductTypeNames";
// import OptionsPermissions from "./Stepper/steps/OptionsPermissions";
import { useLocation } from "react-router-dom";
import { Paper, Box, Typography, Divider } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    width: "100%",
  },
  stepperHeader: {
    padding: "32px 0",
    textAlign: "center",
    backgroundColor: "#F5F9FF",
    position: "relative",
  },
  heading: {
    fontWeight: 500,
    fontSize: 30,
    lineHeight: "100%",
    marginBottom: 20,
  },
  subheading: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "100%",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    color: "#ec6535",
    marginBottom: "1rem",
    marginTop: "1rem",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  sectionPaper: {
    padding: 0,
    marginBottom: 0,
  },
  reviewSection: {
    marginBottom: 50,
    position: "relative",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 0,
    marginBottom: 0,
  },
  editButton: {
    backgroundColor: "#ec6535",
    color: "white",
    "&:hover": {
      backgroundColor: "#d45328",
    },
  },
  saveButton: {
    backgroundColor: "#4caf50",
    color: "white",
    marginRight: theme.spacing(2),
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  discardButton: {
    backgroundColor: "#f44336",
    color: "white",
    "&:hover": {
      backgroundColor: "#d32f2f",
    },
  },
  buttonProgress: {
    color: "white",
    marginLeft: theme.spacing(1),
  },
  noProductDataText: {
    marginTop: 50,
    marginBottom: 50,
    textAlign: "center",
  },
}));

const ViewCMOConfig = () => {
  // useEffect(() => {
  //   const cmoDetailsResponse = JSON.parse(
  //     sessionStorage.getItem("cmoDetailsResponse")
  //   );
  // }, []);

  const location = useLocation();

  const { cmoOrgDetails, cmoVendorDetails, vendorMosymphonyID, brandOwnerMosymphonyID } = location.state;

  const classes = useStyles();
  const history = useHistory();
  const handleGoBack = () => history.goBack();
  const productTypeNamesById = useProductTypeNames();

  return (
    <Paper>
      <Box className={classes.stepperHeader}>
        <Typography className={classes.heading} variant="h5">
          View CMO Details
        </Typography>
        <Typography className={classes.subheading}>
          Please view the CMO details and configurations in the fields below.
        </Typography>
        <Box className={`close-page-action`} onClick={handleGoBack}>
          <Typography>Cancel</Typography>
          <CloseIcon />
        </Box>
      </Box>
      <div
        className="view-cmo-details-content"
        style={{
          padding: "0 32px 50px 32px",

          flexGrow: 1,
        }}
      >
        <CMODetails
          formData={{
            cmoDetails: {
              organizationDetails: cmoOrgDetails,
              status: cmoVendorDetails?.status,
            },
          }}
          readOnly={true}
          hideStepActions={true}
        />

        <SiteDetails
          // formData={{
          //   siteDetails: {
          //     siteId: cmoVendorDetails?.vendorPlantDetails?.plantCode,
          //     siteIdShortName: cmoVendorDetails?.vendorPlantDetails?.plantCodeShortName,
          //     streetAddress1: cmoVendorDetails?.vendorPlantDetails?.siteAddressLine1,
          //     streetAddress2: cmoVendorDetails?.vendorPlantDetails?.siteAddressLine2,
          //     country: cmoVendorDetails?.vendorPlantDetails?.country,
          //     state: cmoVendorDetails?.vendorPlantDetails?.state,
          //     city: cmoVendorDetails?.vendorPlantDetails?.city,
          //     postCode: cmoVendorDetails?.vendorPlantDetails?.zipCode
          //   }
          // }}
          formData={cmoVendorDetails}
          readOnly={true}
          hideStepActions={true}
        />
        <PlantDetails
          formData={{
            
            cmoSites: cmoVendorDetails?.cmoSites || cmoVendorDetails?.vendorPlantDetails?.cmoSites || [],
          
            plantCode: cmoVendorDetails?.plantCode,
            plantCodeShortName: cmoVendorDetails?.plantCodeShortName,
            mainAddress: cmoVendorDetails?.mainAddress || {},
            pickupAddress: cmoVendorDetails?.pickupAddress || {},
            deliveryAddress: cmoVendorDetails?.deliveryAddress || {},
            drugTypeIDList:
              cmoVendorDetails?.drugTypeIDs?.map((type) => type.drugTypeID) ||
              [],
            supplyTypeIDList:
              cmoVendorDetails?.supplyTypeIDs?.map(
                (type) => type.supplyTypeID
              ) || [],
            plantTypeIDList:
              cmoVendorDetails?.plantTypeIDs?.map((type) => type.plantTypeID) ||
              [],
            facilityTypeIDList:
              cmoVendorDetails?.facilityTypeIDs?.map(
                (type) => type.facilityTypeID
              ) || [],
          }}
          selectedCMOFormData={cmoVendorDetails}
          originalVendorPlantDetails={cmoVendorDetails}
          readOnly={true}
          hideStepActions={true}
        />
        <ShipmentConfigurations
          // formData={{
          //   shipmentConfigurations: {
          //     shipmentDuration: cmoVendorDetails?.vendorPlantDetails?.shipmentDuration
          //   }
          // }}
          formData={{
            ...cmoVendorDetails,
            isIDOCRequired: cmoVendorDetails?.isIDOCRequired,
            automateGoodsReceiptProcess: cmoVendorDetails?.automateGRP
              ? "Yes"
              : "No",
            allocationOwnedBySponsor:
              typeof cmoVendorDetails?.allocationOwnedBySponsor === "boolean"
                ? cmoVendorDetails?.allocationOwnedBySponsor
                  ? "Yes"
                  : "No"
                : "NA",
            // Batch Allocation PDF Notification fields
            batchAllocationPdfRequired: cmoVendorDetails?.batchAllocationPDFNotificationReqd
              ? "Yes"
              : "No",
            pdfFieldTo: cmoVendorDetails?.batchAllocationPDFNotificationTo || "CMO Name",
            pdfFieldCC: cmoVendorDetails?.batchAllocationPDFNotificationCC || "All the users associated with the CMO, Brand and Product Type",
            pdfFieldSubject: cmoVendorDetails?.batchAllocationPDFNotificationSubject || "Batch Allocation done for Purchase Order 'PO Number' with Product 'BMS Product Code', Brand 'Brand Name'.",
            pdfFieldObjective: cmoVendorDetails?.batchAllocationPDFNotificationObjective || "The objective of this memo is to notify the 'CMO Name' of allocated (to be consumed) material/component batches for commercial manufacturing of Product 'BMS Product Code', Brand 'Brand name' based on Purchase Order 'PO Number' issued by 'Sponsor Name'.",
            // Fix PO configuration mappings
            cmoUsePOInterface: cmoVendorDetails?.cmoToUsePOInterface
              ? "Yes"
              : "No",
            acceptanceLimitEarlyDelivery:
              cmoVendorDetails?.acceptanceLimitForEarlyDeliveryDateChangeByCMO ||
              "N/A",
            acceptanceLimitLaterDelivery:
              cmoVendorDetails?.acceptanceLimitForLaterDeliveryDateChangeByCMO ||
              "N/A",
            acceptanceLimitLessQuantity:
              cmoVendorDetails?.acceptanceLimitForLessDeliveryQuantityChangeByCMO ||
              "N/A",
            acceptanceLimitMoreQuantity:
              cmoVendorDetails?.acceptanceLimitForMoreDeliveryQuantityChangeByCMO ||
              "N/A",
            cmoDocumentTypesList: cmoVendorDetails?.cmoDocumentTypesList,
          }}
          isViewMode={true}
          readOnly={true}
          hideStepActions={true}
        />
        <PurchasingDetails
          formData={{
            companyCode: cmoVendorDetails?.companyCode,
            poDocType:
              cmoVendorDetails?.poDocumentTypesList?.map(
                (type) => type.poDocumentType
              ) || [],
            purchasingOrgList:
              cmoVendorDetails?.purchasingOrgList?.map((org) => ({
                code: org.purchasingOrgCode,
                description: org.purchasingOrgDescription,
              })) || [],
            purchasingGroupList:
              cmoVendorDetails?.purchasingGroupList?.map((group) => ({
                code: group.purchasingGroupCode,
                description: group.purchasingGroupDescription,
                telephoneNbr: group.purchasingGroupTelephone,
              })) || [],
            cmoIDFromSponsorERP: cmoVendorDetails?.cmoIDFromSponsorERP,
            receivingPlantIDs: cmoVendorDetails?.receivingPlantIDs || [],
            receivingStorageLocationIDs:
              cmoVendorDetails?.receivingStorageLocationIDs || [],
          }}
          readOnly={true}
          hideStepActions={true}
        />
        <Divider style={{ margin: "32px auto", maxWidth: "1270px" }} />
        <div className="cmo-stepper-wrapper">
          <div className="stepper-container">
            <ErpToErpConfigurationSection
              productTypes={(() => {
                const activatedTypes = (cmoVendorDetails?.vendorProductTypeConfigs || [])
                  .filter((pt) => pt.activated === true)
                  .map((pt) => ({
                    productTypeID: pt.productTypeID,
                    productTypeName: pt.productTypeName || productTypeNamesById[pt.productTypeID] || "",
                  }));
                return activatedTypes.length > 0 ? activatedTypes : DEFAULT_PRODUCT_TYPES;
              })()}
              editMode={false}
              initialData={cmoVendorDetails?.erpConfigurations || {}}
              cmoName={cmoOrgDetails?.cmoName}
              vendorMosymphonyID={vendorMosymphonyID}
              brandOwnerMosymphonyID={brandOwnerMosymphonyID}
            />
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default ViewCMOConfig;
